import { createSlice } from '@reduxjs/toolkit';
import {
  deleteOrg,
  getMyOrganisation,
  getOrganisations,
  saveOrganisation,
  searchOrganisations,
} from './organisationsActions';

const initialState = {
  isLoading: false,
  organisations: [],
  myOrganisation: [],
  error: null,
  success: false,
};

const organisationsSlice = createSlice({
  name: 'organisations',
  initialState,
  reducers: {},
  extraReducers: {
    // get organisations
    [getOrganisations.pending]: state => {
      state.isLoading = true;
    },
    [getOrganisations.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.organisations = payload.data;
    },
    [getOrganisations.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    // get my organisation
    [getMyOrganisation.pending]: state => {
      state.isLoading = true;
    },
    [getMyOrganisation.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.myOrganisation = payload.data.organisation;
    },
    [getMyOrganisation.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    // search organisations
    [searchOrganisations.pending]: state => {
      state.isLoading = true;
    },
    [searchOrganisations.fulfilled]: (state, { payload }) => {
      state.isLoading = false;
      state.organisations = payload.data;
    },
    [searchOrganisations.rejected]: (state, { payload }) => {
      state.isLoading = false;
      state.error = payload;
    },
    // save org
    [saveOrganisation.pending]: state => {
      // state.loading = true;
    },
    [saveOrganisation.fulfilled]: (state, { payload }) => {
      state.organisations = payload.isUpdate.state
        ? state.organisations.map(org => {
            if (org.id === payload.isUpdate.organisation.id) {
              return payload.orgData;
            }
            return org;
          })
        : [payload.data, ...state.organisations];
      state.myOrganisation = payload.myOrg
        ? payload.orgData
        : state.myOrganisation;
    },
    [saveOrganisation.rejected]: (state, { payload }) => {
      // state.loading = false;
      state.error = payload;
    },
    // delete org
    [deleteOrg.pending]: state => {
      // state.loading = true;
    },
    [deleteOrg.fulfilled]: (state, { payload }) => {
      state.organisations = state.organisations.filter(
        org => org.id !== payload.orgId
      );
    },
    [deleteOrg.rejected]: (state, { payload }) => {
      // state.loading = false;
      state.error = payload;
    },
  },
});

export default organisationsSlice.reducer;
